import React from 'react';

import EditTemplate from '../../Components/Edit';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

const Title = ({ record }) => (
  <span>Editar Local: {record ? `"${record.nome}"` : ''}</span>
);

function transform({ nome, setor_id, ...data }) {
  return {
    nome,
    setor_id: 1,
    ...data,
  };
}

const Edit = (props) => (
  <EditTemplate
    {...props}
    title={<Title />}
    validate={validate}
    onFailure={Erros}
    transform={transform}
    isBack
  >
    <Form />
  </EditTemplate>
);

export default Edit;
